// extracted by mini-css-extract-plugin
export default {"root":"tK55sf","itemClickWrapper":"r7_2w1","imageZoomBtn":"CsCkjL","sizer":"DncxR3","imageWrapper":"nncEyv","imageBorder":"J7DP2r","image":"Gp5wKv","overlay":"YfXZhc"};